import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";
import { ScrapLayeringReportPage } from "./ScrapYardReportPage";
import { chargesThemeExtension } from "@/pages/sy/theme/chargesTheme";

const ScrapLayeringReport = () => {
  const baseTheme = useTheme();

  // Create extended theme with charges management colors
  // This is needed because we use ChargeStatusTag which requires theme.palette.charges
  const extendedTheme = createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      ...chargesThemeExtension.palette,
    },
  });

  return (
    <ThemeProvider theme={extendedTheme}>
      <Routes>
        <Route index element={<ScrapLayeringReportPage />} />
        <Route path=":chargeId" element={<ScrapLayeringReportPage />} />
      </Routes>
    </ThemeProvider>
  );
};

export default ScrapLayeringReport;
